<div *ngIf="messages.length" class="alert-group mt-2">
  <ngb-alert *ngFor="let alert of messages" [type]="alert.alertType" (close)="close(alert)">{{alert.message}}</ngb-alert>
</div>
